"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleRecaptcha = void 0;
var features_1 = require("../../features");
Object.defineProperty(exports, "GoogleRecaptcha", { enumerable: true, get: function () { return features_1.GoogleRecaptcha; } });
//# sourceMappingURL=index.js.map